import React from 'react'
import { ToolCallPill } from '../ToolCallPill'
import { ToolDetailsPopover } from './ToolDetailsPopover'
import type { ToolRendererProps } from './types'

/**
 * Default fallback renderer for tool calls that don't have custom rendering.
 * Displays a simple pill with the tool name and completion status.
 * When completed, clicking the pill opens a popover with parameters and results.
 */
export function DefaultToolRenderer({
  toolName,
  toolCall,
  toolResponse,
  isCompleted,
  copyText,
}: ToolRendererProps) {
  // Show basic pill without popover while loading
  if (!isCompleted || !toolResponse) {
    return <ToolCallPill toolName={toolName} isCompleted={isCompleted} />
  }

  // Show pill with popover when completed
  return (
    <ToolDetailsPopover
      toolCall={toolCall}
      toolResponse={toolResponse}
      copyText={copyText}
    >
      <ToolCallPill toolName={toolName} isCompleted={isCompleted} />
    </ToolDetailsPopover>
  )
}
